import {
  createUnifiedTheme,
  palettes,
  createBaseThemeOptions,
} from '@backstage/theme';

export const backstageTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#a10000',
      },
      secondary: {
        main: '#a10000',
      },
      error: {
        main: '#d32f2f',
      },
      warning: {
        main: '#f57c00',
      },
      info: {
        main: '#1976D2',
      },
      success: {
        main: '#388e3c',
      },
      background: {
        default: '#f5f5f5',
        paper: '#fff',
      },
      banner: {
        info: '#1976D2',
        error: '#d32f2f',
        text: '#343b58',
        link: '#565a6e',
      },
      text: {
        primary: 'rgba(0,0,0,0.87)',
        secondary: 'rgba(0,0,0,0.54)',
        disabled: 'rgba(0,0,0,0.38)',
        hint: 'rgba(0,0,0,0.38)',
      },
      errorBackground: '#d32f2f',
      warningBackground: '#f57c00',
      infoBackground: '#1976D2',
      navigation: {
        ...palettes.light.navigation,
        background: '#eeeeee',
        indicator: '#a10000',
        color: '#9E9E9E',
        selectedColor: '#404040',
        navItem: {
          hoverBackground: 'rgba(0, 0, 0, 0.04)',
        },
      },
    },
  }),
  defaultPageTheme: 'home',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  components: {
    BackstageHeader: {
      styleOverrides: {
        header: ({ theme }) => ({
          width: 'auto',
          boxShadow: 'none',
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          background: '#a10000',
          backgroundImage: 'unset',
          color: `${theme.palette.common.white}`,
        }),
      },
    },
    BackstageSidebarDivider: {
      styleOverrides: {
        root: ({ theme }) => ({
          background: `${theme.palette.grey[300]}`,
        }),
      },
    },
    MuiPaper: {
      defaultProps: {
        variant: 'outlined',
      },
    },
  },
});
